<template>
  <button
      :class="[
        `type-${type}`,
        `size-${size}`,
      ]"
      @click="$emit('click', $event)">
    <div
        v-if="icon"
        class="icon">
      {{ icon }}
    </div>
    <span v-if="text">
      {{ text }}
    </span>
  </button>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    icon: String,
    text: String,
    type: {
      type: String,
      default: 'normal',
      validator: value => [
        'normal',
        'transparent',
      ].includes(value),
    },
    size: {
      type: String,
      default: 'normal',
      validator: value => [
        'tiny',
        'small',
        'normal',
        'large',
      ].includes(value),
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

@mixin icon-size($size) {
  .icon {
    font-size: $size;
    height: $size;
    line-height: $size;
    width: $size;
  }
}

button {
  align-items: center;
  border-radius: 0.25rem;
  border: none;
  color: $text;
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  justify-content: center;
  outline: none;
  padding: 0.5rem;
  transition: background .2s;
  user-select: none;
  vertical-align: middle;

  .icon {
    transition: color .2s;
  }

  span {
    margin: 0 0.25rem;
  }

  .icon + span {
    margin-left: 0.625rem;
  }

  &.type- {
    &normal {
      background: $button-background;

      &:disabled {
        background: $button-background-disabled;
        color: $disabled-text;
      }

      &:not(:disabled) {
        &:focus {
          background: $button-background-focus;
        }

        &:hover {
          background: $button-background-hover;
        }

        &:active {
          background: $button-background-active;
        }
      }
    }

    &transparent {
      background: transparent;

      &:disabled {
        color: $disabled-text;
      }

      &:not(:disabled) {
        &:focus {
          background: $button-background-focus;
        }

        &:hover {
          background: $button-transparent-background-hover;
        }

        &:active {
          background: $button-transparent-background-active;
        }
      }
    }
  }

  &.size- {
    &tiny {
      @include icon-size(0.75rem);
      margin: 0.125rem;
      padding: 0.25rem;

      span {
        font-size: 0.625rem;
        line-height: 0.75rem;
      }
    }

    &small {
      @include icon-size(1rem);
      margin: 0.25rem;
      padding: 0.375rem;

      span {
        font-size: 0.875rem;
        line-height: 1rem;
      }
    }

    &normal {
      @include icon-size(1.25rem);
      margin: 0.375rem;

      span {
        font-size: 1rem;
        line-height: 1.25rem;
      }
    }

    &large {
      @include icon-size(1.75rem);
      margin: 0.375rem;

      span {
        font-size: 1.5rem;
        line-height: 1.75rem;
      }
    }
  }
}
</style>
